import request from '@/axios/http'





// 获取缩水师对应的角色列表
export function shrinkage_role_list (data) {
	return request({
		// url: '/stage-api/lottery/shrinkage/role/list',
		url: '/stage-api/lottery/shrinkage/identity/role/list',
		method: 'get',
		data
	})
}
// 获取技巧师对应的角色列表
export function technician_role_list (data) {
	return request({
		url: '/stage-api/lottery/technician/role/list',
		method: 'get',
		data
	})
}
// 获取软件师对应的角色列表
export function software_role_list (data) {
	return request({
		url: '/stage-api/lottery/software/role/list',
		method: 'get',
		data
	})
}
// 获取入驻彩种（彩票投注站 / 彩票代表申请共用）
// type 取值：BETTING_SHOP_ASSIST（投注站帮扶）/ LOTTERY_MANAGER（彩票代表）
export function representative_role_list (params) {
	return request({
		url: '/stage-api/assist/representative/role/list',
		method: 'get',
		params
	})
}

// 申请注册缩水师
export function shrinkage_register (data) {
	return request({
		url: '/stage-api/lottery/shrinkage/identity/register',
		method: 'put',
		data
	})
}
// 技巧师申请
export function technician_register (data) {
	return request({
		url: '/stage-api/lottery/technician/register',
		method: 'put',
		data
	})
}
// 软件交易师申请（新接口：POST /stage-api/software/trader/apply）
export function software_register (data) {
	return request({
		url: '/stage-api/software/trader/apply',
		method: 'post',
		data
	})
}
// 彩票投注站帮扶申请（POST /stage-api/assist/betting/shop/apply）
export function bettingShopApply (data) {
	return request({
		url: '/stage-api/assist/betting/shop/apply',
		method: 'post',
		data
	})
}

// 众筹招股大厅 - 投注站列表（GET /stage-api/assist/betting/shop/list）
// 参数：preType(0=双色球,1=大乐透) type(0=最新一期,1=上一期,2=下一期) preNumber(期号) pageNum pageSize
export function bettingShopList (params) {
	return request({
		url: '/stage-api/assist/betting/shop/list',
		method: 'get',
		params
	})
}

// 彩票代表申请（POST /stage-api/assist/representative/apply）
export function representativeApply (data) {
	return request({
		url: '/stage-api/assist/representative/apply',
		method: 'post',
		data
	})
}




// 获取当前登录用户信息
export function shrinkage_identity (data) {
	return request({
		url: '/stage-api/lottery/shrinkage/identity',
		method: 'get',
		data
	})
}

// ==================== 众筹招股（散户侧，对齐 BettingShopController） ====================

// 众筹招股详情（散户视角，含本人认购 mySubscribe 与认购人清单 purchaserList）
// 接口：GET /stage-api/assist/betting/shop/offering/detail/{id}
// 返回：Result<AssistStockRightPO> → 响应拦截器归一化为 { code, msg, data }，取 res.data
export function bettingShopOfferingDetail(id) {
	return request({
		url: '/stage-api/assist/betting/shop/offering/detail/' + id,
		method: 'get',
	})
}

// 散户认购众筹股权
// 接口：POST /stage-api/assist/betting/shop/subscribe
// Body：{ crowdfundingId:Long(必需，众筹id), purchaserNumber:Long(≥1,必需，认购股数) }
// 说明：校验众筹存在/未截止/未重复认购/剩余股数足够；写入认购明细。前端按每股价格×股数提示应付缩币（实际扣减由后端处理）。
export function bettingShopSubscribe(data) {
	return request({
		url: '/stage-api/assist/betting/shop/subscribe',
		method: 'post',
		data,
	})
}

// 散户「我的认购记录」列表
// 接口：GET /stage-api/assist/betting/shop/my/subscribe/list
// 返回：TableDataInfo → res.rows / res.total；rows 为 MySubscribeVO
export function bettingShopMySubscribeList(params) {
	return request({
		url: '/stage-api/assist/betting/shop/my/subscribe/list',
		method: 'get',
		params: {
			...(params || {}),
			pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
			pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
		},
	})
}

// 我发布的众筹招股列表（投注站侧，含认购人明细）
// 接口：GET /stage-api/assist/betting/shop/my/offering/list
// Query：preType(可选) / issueNumber(可选) / pageNum / pageSize
// 返回：TableDataInfo → res.rows / res.total；rows 为 AssistStockRightPO
export function bettingShopMyOfferingList(params) {
	return request({
		url: '/stage-api/assist/betting/shop/my/offering/list',
		method: 'get',
		params: {
			...(params || {}),
			pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
			pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
		},
	})
}

// 已认购散户查看某招股四件套披露（帮扶合同+实战方案+实战票+签名拍照）
// 接口：GET /stage-api/assist/betting/shop/contract/offering/{crowdfundingId}
// 返回：Result<AssistContractPO>（未认购或投注站尚未上传返回 null）
// 注：仅该招股的零售认购用户可查看；前端在 mySubscribe 非空时才展示入口。
export function bettingShopContractOffering(crowdfundingId) {
	return request({
		url: '/stage-api/assist/betting/shop/contract/offering/' + crowdfundingId,
		method: 'get',
	})
}

// ===== 众筹招股 运营闭环（股权/分红/兑奖/打款凭证/分红二维码） =====

// 股权清单（与详情同结构 AssistStockRightPO）
// 接口：GET /stage-api/assist/betting/shop/equity/list?id=
// 返回：Result<AssistStockRightPO>
export function bettingShopEquityList(id) {
	return request({
		url: '/stage-api/assist/betting/shop/equity/list',
		method: 'get',
		params: { id },
	})
}

// 投注站兑奖列表（按彩种+期号查中奖认购明细）
// 接口：GET /stage-api/assist/betting/shop/claim/prize
// Query：pageNum / pageSize / issueNumber(必填) / lotteryType(必填) / type(0上一期 1下一期，可选)
// 返回：TableDataInfo → res.rows / res.total；rows 为 AssistCrowdfundingDetailsPO
export function bettingShopClaimPrize(params) {
	return request({
		url: '/stage-api/assist/betting/shop/claim/prize',
		method: 'get',
		params: {
			...(params || {}),
			pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
			pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
		},
	})
}

// 上传派奖打款凭证（标记该认购明细已派奖 bonusStatus=已派奖）
// 接口：POST /stage-api/assist/betting/shop/remit/upload
// Body：CrowdfundingRemitVO { detailId(认购明细id,必填), remit(打款凭证图片URL,必填) }
export function bettingShopRemitUpload(data) {
	return request({
		url: '/stage-api/assist/betting/shop/remit/upload',
		method: 'post',
		data,
	})
}

// 众筹分红 H5 页二维码（Base64，开奖且已配置 share-dividend-domain 才有值）
// 接口：GET /stage-api/assist/betting/shop/share/dividend/qrcode/base64?id=
// 返回：Result<String> → data:image/png;base64,...
export function bettingShopShareDividendQrcode(id) {
	return request({
		url: '/stage-api/assist/betting/shop/share/dividend/qrcode/base64',
		method: 'get',
		params: { id },
	})
}

// 分红 H5 页数据（匿名，扫码打开的分红明细页使用）
// 接口：GET /stage-api/assist/betting/shop/share/dividend/detail?id=
// 返回：Result<AssistStockRightPO> → res.data（结构同 /equity/list）
export function bettingShopShareDividendDetail(id) {
	return request({
		url: '/stage-api/assist/betting/shop/share/dividend/detail',
		method: 'get',
		params: { id },
	})
}

// 投注站上传帮扶四件套（认购后披露材料）
// 接口：POST /stage-api/assist/betting/shop/upload/signature/contract
// Body：AssistContractVO { nickname, phoneNumber, identityCardName, identityCardNo,
//        practicalSchemes(方案txt URL), practicalTicket(实战票图片URL),
//        signature(承诺签名拍照URL), contractSignature(签名后合同拍照URL),
//        crowdfundingId(招股ID), issueNumber(期号), bettingShop(投注站地址), bettingShopNumber(投注站编号) }
// 返回：Result<String>
export function uploadSignatureContract(data) {
	return request({
		url: '/stage-api/assist/betting/shop/upload/signature/contract',
		method: 'post',
		data,
	})
}

// ===== 众筹招股「自动跟注」（按投注站隔离） =====
// 跟注跟的是投注站：用户在某投注站认购过众筹后，可开启对该投注站的跟注；
// 之后只有【该投注站】新发布的众筹招股会自动跟注，其他投注站发布的不跟。

// 查询当前用户对某个投注站的跟注设置
// 接口：GET /stage-api/assist/betting/shop/crowdfunding/follow/setting?shopUserId=xx
// 返回：res.data = { enabled(1开/0关), shares, shopUserId, shopName, startCrowdfundingId, lastFollowTime }
// 注：从未对该站设置过时返回默认对象（enabled=0、shares=2），不会落库。
export function crowdfundingFollowSetting(shopUserId) {
	return request({
		url: '/stage-api/assist/betting/shop/crowdfunding/follow/setting',
		method: 'get',
		params: { shopUserId },
	})
}

// 保存对某个投注站的跟注设置（开启/关闭 + 跟注股数）
// 接口：POST /stage-api/assist/betting/shop/crowdfunding/follow/setting
// Body：{ shopUserId:Long(必填), enabled:Boolean(必填), shares:Long(必填，1~8) }
// 说明：开启前要求用户认购过【该投注站】的众筹；「关闭→开启」会刷新跟注起点，仅改股数不刷新。
// 返回：Result<String> → res.msg 为提示文案，如「已开启对「xx」的自动跟注」。
export function crowdfundingFollowSave(data) {
	return request({
		url: '/stage-api/assist/betting/shop/crowdfunding/follow/setting',
		method: 'post',
		data,
	})
}

// 取消对某个投注站的跟注
// 接口：POST /stage-api/assist/betting/shop/crowdfunding/follow/cancel/{shopUserId}
// 说明：删除该投注站的跟注设置，历史跟注流水与已产生的认购明细保留。
export function crowdfundingFollowCancel(shopUserId) {
	return request({
		url: `/stage-api/assist/betting/shop/crowdfunding/follow/cancel/${shopUserId}`,
		method: 'post',
	})
}

// 我的跟注（投注站列表）：一个被跟注的投注站一行
// 接口：GET /stage-api/assist/betting/shop/crowdfunding/follow/shop/list
// 返回：Result<List> → res.data = [{ followId, shopUserId, shopName, enabled, shares,
//       createTime, lastFollowTime, subscribedIssueCount, followTimes, subscribed }]
export function crowdfundingFollowShopList() {
	return request({
		url: '/stage-api/assist/betting/shop/crowdfunding/follow/shop/list',
		method: 'get',
	})
}

// 跟注股数身份上限（与认购单人上限同一口径：散户2股，缩水师/技巧师/软件工程师每具备一种+2，封顶8）
// 接口：GET /stage-api/assist/betting/shop/crowdfunding/follow/limit
export function crowdfundingFollowLimit() {
	return request({
		url: '/stage-api/assist/betting/shop/crowdfunding/follow/limit',
		method: 'get',
	})
}

// 我的跟注记录（自动跟注流水，含成功与失败原因）
// 接口：GET /stage-api/assist/betting/shop/crowdfunding/follow/my/log/list
// 参数：pageNum / pageSize / shopUserId（可选，不传表示不限投注站）
// 返回：TableDataInfo → res.rows / res.total；rows 为 CrowdfundingFollowLogVO
// status：1成功 2余额不足 3剩余份额不足 4超出个人认购上限 5发布方本人 9其他异常
export function crowdfundingFollowMyLogList(params) {
	return request({
		url: '/stage-api/assist/betting/shop/crowdfunding/follow/my/log/list',
		method: 'get',
		params: {
			...(params || {}),
			pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
			pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
		},
	})
}

// ===== 帮扶中心「收益记录」（彩票经理/代表） =====

// 彩票代表收入明细
// 接口：GET /stage-api/assist/represent/income/list
// Query：userName(可选,模糊) / startTime / endTime(yyyy-MM-dd HH:mm:ss) / pageNumber(从1) / pageSize
// 返回：TableDataInfo → res.rows / res.total；rows 为 RepresentIncomeDetailDTO：
// { userId, userName, managerName(上级经理), shopId, shopName, balance(收益账户余额),
//   ssqEightWinFive, dltEightWinFive, remit(打款截图), number(期号), preType, preIndexType(彩种),
//   purchaserNumber(认购股数), payable(应得分红), createTime(认购时间), nickname/phone(站长昵称/电话) }
export function assistRepresentIncomeList(params) {
	return request({
		url: '/stage-api/assist/represent/income/list',
		method: 'get',
		params,
	})
}

// 彩票经理收入明细（入参/出参同上；userName 变为经理名，行内 representName 为名下代表）
// 接口：GET /stage-api/assist/manager/income/list
export function assistManagerIncomeList(params) {
	return request({
		url: '/stage-api/assist/manager/income/list',
		method: 'get',
		params,
	})
}

// 帮扶合同档案中心列表（众筹招股四件套归档查阅）
// 接口：GET /stage-api/assist/betting/shop/contract/archive/list
// Query：pageNum / pageSize / crowdfundingId / nickname / phoneNumber / identityCardName /
//        identityCardNo / bettingShop / bettingShopNumber / startTime / endTime
// 返回：TableDataInfo → res.rows / res.total；rows 为 AssistContractPO
export function contractArchiveList(params) {
	return request({
		url: '/stage-api/assist/betting/shop/contract/archive/list',
		method: 'get',
		params: {
			...(params || {}),
			pageNum: params && params.pageNum !== undefined ? Number(params.pageNum) : 1,
			pageSize: params && params.pageSize !== undefined ? Number(params.pageSize) : 10,
		},
	})
}

